import InputFieldHelpLabel from '../../../../form/InputFieldHelpLabel';
import {TooltipAndOverlayIDs} from '../../../detailed-tooltip/TooltipLibrary';
import {onlyDeliveryAddresses} from '../addressFormType';

export default {
  name: 'postalId',
  label: 'postal.id',
  filterCondition: onlyDeliveryAddresses,
  helperText:
  <InputFieldHelpLabel
    overlay={TooltipAndOverlayIDs.POSTAL_ID_INFO}
    linkTranslationKey="checkout.delivery.address.field.postal.id.hint.link"
    fieldName="postalId"
  />,
};
